import { Producto } from "./producto";

export class NotaCreditoDetalle{
    public constructor(
        public id: String = "",
        public cantidad: number = 0,
        public cantidad_original: number = 0,
        public precio_unitario: number = 0,
        public desc_valor: number = 0,
        public desc_porcent: number = 0,
        public subtotal: number = 0,
        public iva: number = 0,
        public porct_iva: number = 0,
        public total: number = 0,
        public detalle: String = "",
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public nota_credito_id: String = "",
        public producto_id: String = "",
        public status: String = "",
        public usuario_id: String = "",

        public producto: Producto = new Producto(),
        public cuenta_ingreso_id: String = "",
        public cuenta_inventario_id: String = "",
        public cuenta_costo_gasto_id: String = "",
    ){
        //
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/nota-credito-detalle.ts